var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("tips"),
            visible: _vm.dialogVisible,
            width: "30%",
            top: "15%",
            "before-close": _vm.closeDia,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tip-style" }, [
            _c("p", [_vm._v(_vm._s(_vm.tipsText))]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn-plain",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.closeDia },
                },
                [_vm._v(_vm._s(_vm.buttonText))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }